export default __webpack_public_path__ + "static/nopagination-fff5e192a396b73c77064c3afaada87c.png";